<template>
  <div class="Footer">
    <div class="Footers">
      <span class="Footerss"> 主管单位：教育部职业教育与成人教育司</span
      ><span class="Footerss">技术支持单位：教育部教育管理信息中心</span
    >
    </div>
  </div>
</template>
<script>
export default {
  // 组件名字
  name: "App",
  // 状态数据
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.Footer {
  width: 100%;

  background: #3b3b3b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
  justify-content: space-around;

  .Footers {
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;

    .Footerss {
      margin-right: 30px;
      font-size: 1rem;
      line-height: 80px;
      font-weight: 400;
      color: #fff;
    }
  }
}
</style>
